import { render, staticRenderFns } from "./CoktelesEmbajadores.vue?vue&type=template&id=15b428ee&scoped=true&"
import script from "./CoktelesEmbajadores.vue?vue&type=script&lang=js&"
export * from "./CoktelesEmbajadores.vue?vue&type=script&lang=js&"
import style0 from "./CoktelesEmbajadores.vue?vue&type=style&index=0&id=15b428ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b428ee",
  null
  
)

export default component.exports